export function setViewType(viewType) {
  return {
    type: 'SET_VIEW_TYPE',
    viewType
  };
}

export function setGridConfig(values) {
  return {
    type: 'SET_GRID_CONFIG',
    values
  };
}

export function setGridConfigPDP(values) {
  return {
    type: 'SET_GRID_CONFIG_PDP',
    values
  };
}

export function setGridColumns(gridColumns) {
  return {
    type: 'SET_GRID_COLUMN',
    gridColumns
  };
}
